function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.83722 11.3488L6.83722 6.83719L11.3488 6.83719C11.5544 6.83719 12 6.55811 12 5.99998C12 5.44184 11.5543 5.16276 11.3488 5.16276L6.83719 5.16276L6.83719 0.651161C6.83722 0.445663 6.55814 -2.37871e-07 6.00002 -2.62267e-07C5.44191 -2.86663e-07 5.16281 0.445663 5.16281 0.651161L5.16281 5.16279L0.651163 5.16279C0.445689 5.16279 -2.3787e-07 5.44184 -2.62268e-07 6C-2.86666e-07 6.55816 0.445689 6.83721 0.651163 6.83721L5.16281 6.83721L5.16281 11.3488C5.16281 11.5543 5.44186 12 6.00002 12C6.55819 12 6.83722 11.5543 6.83722 11.3488Z"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.bdf7ed1f.svg";
export { ForwardRef as ReactComponent };